import React from 'react';
import ReactDOM from 'react-dom';
import Helmet from "react-helmet";
import {
  BrowserRouter,
  Switch,
  Route,
  Redirect,
} from 'react-router-dom';

// UI lib imports
import { DinoTypography } from '@uchi/ui-lib-react';
// pages
import FirstPage from './pages/FirstPage/FirstPage';
import Сatalog from './pages/Catalog/Catalog';
import Vacancy from './pages/Vacancy/Vacancy';
import Referal from './pages/Referal/Referal';
import SpecialVacancy from './pages/Vacancy/SpecialVacancy';
import About from './pages/About/About'
import * as serviceWorker from './serviceWorker';
// components
import AppWrapper from './AppWrapper';
import ScrollToTop from './common/components/Scroll2Top/Scroll2Top.jsx';
// Analytics
import GA from './common/components/analytics/GA.tsx';
// styles
import './index.css';

ReactDOM.render((
   <AppWrapper>
      <Helmet
        htmlAttributes={{"lang": "ru", "amp": undefined}}
        title="Вакансии в городах России"
        titleTemplate="Uchi.ru - %s"
        defaultTitle="Карьера в Uchi.ru"
        meta={[
          {"name": "description", "content": "Карьера в Uchi.ru"},
          {"property": "og:type", "content": "article"},
          { property: 'og:site_name', content: "Карьера в Uchi.ru" },
          { name: 'twitter:site', content: "careers.uchi.ru" },
          { name: 'twitter:title', content: "Карьера в Uchi.ru" },
          // { name: 'twitter:image', content: some.image },

          { property: 'og:title', content: "Карьера в Uchi.ru" },
          { property: 'og:site_name', content: "Карьера в Uchi.ru" },
          { property: 'og:type', content: "website" },
          // { property: 'og:url', content: "https://careers.uchi.ru" },
          { property: 'og:description', content: "Вакансии в городах России" },
          // { property: 'og:image', content: some.image },
        ]}
      />
      <DinoTypography>
        <BrowserRouter>
          <GA />
          <ScrollToTop></ScrollToTop>
          <Switch>
            <Redirect from="/:url*(/+)" to={window.location.pathname.slice(0, -1)} />
            <Route exact path="/" component={FirstPage} />
            <Route exact path="/referral" component={Referal} />
            <Route exact path="/about" component={About} />
            <Route exact path="/special-vacancy" component={SpecialVacancy} />
            <Route exact path="/:city" component={Сatalog} />
            <Route exact path="/:city/:vacancy" component={Vacancy} />
            <Route exact path="/:city/:area/special-vacancy" component={SpecialVacancy} />
          </Switch>
        </BrowserRouter>
      </DinoTypography>
  </AppWrapper>
// eslint-disable-next-line no-undef
), document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
